export const parsePhoneNumber = (prefixList, phoneNumber) => {
    if (!phoneNumber || !prefixList) {
        return [null, null];
    }
    const prefixes = prefixList.split(",");
    for (const prefix of prefixes) {
        if (phoneNumber.startsWith(prefix)) {
            return [prefix, phoneNumber.slice(prefix.length)];
        }
    }
    return [null, null];
};
//# sourceMappingURL=parsePhoneNumber.js.map